import PhoneField from "./PhoneField";
import { M_InputTextField } from "../M_Components";

export const FIELD_OVERRIDES = {
  "account.OfficePhone": PhoneField,
  "account.OfficePhone2": PhoneField,
};

export const DefaultRenderer = (p) => <M_InputTextField {...p} />;

export function getRenderer(entity, fieldMeta) {
  const key = `${String(entity)}.${String(fieldMeta.Name)}`;
  return FIELD_OVERRIDES[key] || DefaultRenderer;
}